// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"47fb3657","20":"f1162f2c","365":"0c7d3093","565":"1623b084","626":"dac84737"}[chunkId] + ".chunk.js";
};